<template>
  <aside :class="['aui-sidebar']">
    <div class="aui-sidebar__inner">
      <el-menu
        :default-active="$store.state.sidebarMenuActiveName"
        :collapse="$store.state.sidebarFold"
        :unique-opened="true"
        :collapseTransition="false"
        class="aui-sidebar__menu">
        <sub-menu v-for="menu in $store.state.sidebarMenuList" :key="menu.id" :menu="menu" />
      </el-menu>
    </div>
  </aside>
</template>

<script>
import SubMenu from './main-sidebar-sub-menu'
export default {
  data () {
    return {
    }
  },
  components: {
    SubMenu
  },
  created () {
    // 侧边栏隐藏System Settings(管理页仍可通过URL直达); 只展示Table/Chart等业务菜单
    this.$store.state.sidebarMenuList = (window.SITE_CONFIG['menuList'] || []).filter(
      (m) => m.url !== '/systemSettings' && m.name !== 'System Settings'
    )
  }
}
</script>
<style lang="scss" scoped>
	.aui-sidebar{
		background: #304156;
	}
	::v-deep .el-menu{
		background: #304156;
	}
	::v-deep .el-menu-item{
		color: rgb(191, 203, 217);
	}
	/* 当前页面的菜单项保持高亮(不依赖focus, 页面内操作后仍然可见) */
	::v-deep .el-menu-item.is-active{
		background: #1f2d3d !important;
		color: #409EFF !important;
		border-right: 3px solid #409EFF;
	}
	::v-deep .el-submenu__title{
		color: rgb(191, 203, 217);
	}
	::v-deep .el-submenu__title:hover{
		background: rgba(0, 0, 0, 0.06);
	}
	::v-deep .el-menu-item:focus, .el-menu-item:hover{
		background: rgba(0, 0, 0, 0.06);
		color: #409EFF; 
	}
	::v-deep .el-submenu__title:focus, .el-submenu__title:hover{
		background: rgba(0, 0, 0, 0.06);
	}
	::v-deep .el-menu-item:focus, .el-menu-item:hover{
		background: rgba(0, 0, 0, 0.06);
	}
	::v-deep .el-menu-item:hover{
		background: rgba(0, 0, 0, 0.06);
	}
</style>
